import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowUpRight, Menu, X } from "lucide-react";
import Logo from "./Logo";
import { NAV_LINKS, PHONE_DISPLAY, PHONE_TEL } from "../data/mock";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-cream/90 backdrop-blur-md border-b border-navy/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 h-[76px] flex items-center justify-between">
        <Link to="/" aria-label="CallRetrieve home">
          <Logo size={38} />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[15px] text-navy/75 hover:text-navy transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-6">
          <a
            href={`tel:${PHONE_TEL}`}
            className="flex items-center gap-2 text-[15px] font-medium text-navy hover:text-teal transition-colors"
          >
            <Phone className="w-4 h-4" />
            <span className="font-mono">{PHONE_DISPLAY}</span>
          </a>
          <Link
            to="/login"
            className="text-[15px] text-navy/60 hover:text-navy transition-colors"
          >
            Client Login
          </Link>
          <a
            href="#contact"
            className="group inline-flex items-center gap-1.5 bg-navy text-cream text-[15px] font-medium pl-5 pr-4 py-2.5 rounded-full hover:bg-navy-800 transition-colors"
          >
            Get started
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </div>

        <button
          className="lg:hidden text-navy p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-cream border-t border-navy/10 px-5 py-6 space-y-4">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-lg text-navy/80"
            >
              {l.label}
            </a>
          ))}
          <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 text-navy font-medium">
            <Phone className="w-4 h-4" /> <span className="font-mono">{PHONE_DISPLAY}</span>
          </a>
          <Link to="/login" onClick={() => setOpen(false)} className="block text-navy/70">Client Login</Link>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="inline-flex items-center gap-1.5 bg-navy text-cream font-medium px-6 py-3 rounded-full"
          >
            Get started <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      )}
    </header>
  );
}
